// test1962
(1962 && 0);
